import React from "react";
import { IconKey, iconMap } from "./constant";
import './index.scss';
import { useIntl } from "umi";
import { getLanguage } from "@home/utils/common";
import { LANGUAGE_EN } from "@home/_config/config";
import Abnormal from "@home/components/Abnormal";
import COMMON from '@/pages/home/assets/svg/studio//opinions/common.svg';

interface IHighlightItem {
  highlight: string;
  titleEn: string;
  titleCn: string;
  executive_summary: string;
}

interface IHighlightsReport {
  gameInfo?: { [key: string]: string; };
  filter: { [key: string]: string; };
  error: boolean;
  loading: boolean;
  reportData: IHighlightItem[];
  normalNoContentEn: string;
  normalNoContentCn: string;
  editPermission: boolean;
  setClickAddHighlight: (arg0: boolean) => void;
  clickAddHighlight: boolean;
}

export default function HighlightsReport(props: IHighlightsReport) {
  const { 
    reportData, 
    error, 
    loading, 
    editPermission, 
    normalNoContentEn, 
    normalNoContentCn,     
    setClickAddHighlight
  } = props;

  const { formatMessage, locale } = useIntl();
  const isEN = locale === LANGUAGE_EN;

  let content;

  if (reportData.length > 0) {
    content = reportData.map((item, index) => (
      <div key={index} className="dbh-highlights-crud-content">
        <img
          src={iconMap[item.highlight as IconKey] || COMMON}
          className="dbh-highlights-crud-item-icon"
        />
        <div>
          <div className="dbh-highlights-crud-item-title">
            {getLanguage(isEN, item?.titleEn, item?.titleCn)}
          </div>
          <div className="dbh-highlights-crud-item-summary">
            <span className="dbh-highlights-crud-item-summary" dangerouslySetInnerHTML={{ __html: item?.executive_summary as string }}></span>
          </div>
        </div>
      </div>
    ));
  } else if (editPermission) {
    content = (
      <div className="dbh-highlights-no-content">
        {formatMessage({ id: 'dbh_studio_no_content' })},&nbsp;
        <span 
          className="dbh-highlights-no-content-add-btn" 
          onClick={() => setClickAddHighlight(true)}
        >
          {formatMessage({ id: 'dbh_studio_add_highlights' })}
        </span>
      </div>
    );
  } else {
    content = (
      <div className="dbh-highlights-no-content">
        {getLanguage(isEN, normalNoContentEn, normalNoContentCn)}
      </div>
    );
  }

  return (
    <Abnormal
      isLoading={loading}
      isError={error}
      classNames={'dbh-highlights-crud-abnormal'}
      component={<div className="dbh-highlights-crud">{content}</div>}
    />
  );
}
